import { makeStyles } from "@/utils"
import { themeColors } from "@/styles"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	navItem: {
		position: "relative",
		display: "flex",
		width: "100%",
		alignItems: "center",
		justifyContent: "flex-start",
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5),
		paddingLeft: theme.spacing(2),
		paddingRight: 0,
		borderRadius: theme.spacing(1),
		cursor: "pointer",
		transition: theme.transitions.create(["background-color"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.shortest
		}),
		textDecoration: "none",
		color: "inherit"
	},
	navItemPrimary: {
		color: colors.gray[700],
		"&:hover": {
			backgroundColor: colors.gray[100]
		}
	},
	navItemSecondary: {
		color: themeColors.colors.base.white,
		"&:hover": {
			backgroundColor: colors.purple[700]
		}
	},
	navItemActivePrimary: {
		color: colors.purple[500],
		"&:hover": {
			backgroundColor: colors.gray[100]
		},
		"&::before": {
			content: "\"\"",
			position: "absolute",
			left: 0,
			top: 0,
			width: "4px",
			height: "100%",
			backgroundColor: colors.getPrimaryColor()
		}
	},
	navItemActiveSecondary: {
		backgroundColor: colors.purple[700],
		color: themeColors.colors.base.white,
		"&:hover": {
			backgroundColor: colors.purple[700]
		},
		"&::before": {
			content: "\"\"",
			position: "absolute",
			left: 0,
			top: 0,
			width: "4px",
			height: "100%",
			backgroundColor: colors.getPrimaryColor()
		}
	},
	navItemHighlighted: {
		color: colors.green[600],
		fontWeight: 700
	},
	navItemMuted: {
		color: colors.gray[500]
	},
	navItemLabelRow: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1)
	},
	navItemCollapsed: {
		justifyContent: "center",
		padding: theme.spacing(0),
		minHeight: theme.spacing(6)
	},
	navItemIcon: {
		display: "flex",
		alignItems: "center",
		flexShrink: 0,
		minWidth: theme.spacing(5)
	},
	navItemIconCollapsed: {
		minWidth: "auto",
		justifyContent: "center"
	},
	navItemLabel: {
		marginLeft: theme.spacing(1),
		whiteSpace: "nowrap",
		overflow: "hidden",
		color: "inherit",
		transition: theme.transitions.create(["opacity", "width"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	navItemLabelVisible: {
		opacity: 1,
		width: "auto"
	},
	navItemLabelHidden: {
		opacity: 0,
		width: 0,
		marginLeft: 0,
		flex: "0 0 auto"
	}
}))

export default useStyles
